import { Button, Center, Select, Text } from "@chakra-ui/react";
import React, { useMemo, useRef } from "react";
import { FixedSizeList as List } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
import { mergeRefs } from "../../core/utils";

const PaginationControls = ({
  currentPage,
  totalPages,
  totalItems,
  handleJumpTo,
  onClickFirst,
  onClickLast,
}) => {
  return (
    <Center flexDirection="row" display="flex" spacing={4} p="3">
      <Button
        variant="outline"
        disabled={currentPage === 1}
        onClick={onClickFirst}
      >
        First
      </Button>
      <Center px="3">
        <Text pr="2">Jump to: </Text>
        <Select onChange={(e) => handleJumpTo(e)} value={currentPage} w="150">
          {Array.from({ length: totalPages }, (v, i) => i + 1).map((j) => (
            <option key={j} value={j}>{`${(j - 1) * 500 + 1} - ${
              j * 500 < totalPages * 500 ? j * 500 : totalItems
            }`}</option>
          ))}
        </Select>
      </Center>
      <Button
        variant="outline"
        disabled={currentPage === totalPages}
        onClick={onClickLast}
      >
        Last
      </Button>
    </Center>
  );
};

const PaginatedList = ({ items, totalItems, renderRow, loadMoreItems }) => {
  const listRef = useRef();
  const itemData = useMemo(() => items, [items]);

  let navbar = document.querySelector("header nav");
  let navbarHeight = navbar.offsetHeight;
  let availableHeight = window.innerHeight - navbarHeight - 150;

  return (
    <div>
      <InfiniteLoader
        isItemLoaded={() => true}
        itemCount={totalItems || 5000}
        loadMoreItems={loadMoreItems}
      >
        {({ onItemsRendered, ref }) => (
          <List
            height={
              items.length < 8 ? items.length * 52 + 52 + 52 : availableHeight
            } // Adjust based on your layout
            itemCount={items.length}
            itemSize={52} // Adjust based on your row height
            itemData={itemData}
            width={"100%"} // Adjust as needed
            onItemsRendered={onItemsRendered}
            ref={mergeRefs(ref, listRef)}
          >
            {renderRow}
          </List>
        )}
      </InfiniteLoader>
    </div>
  );
};

export { PaginationControls, PaginatedList };

export default PaginatedList;
